import React, { useEffect, useMemo, useState } from "react";
import api from "../../lib/api";
import { Activity, Loader, PauseCircle, CheckCircle2, Users, FolderKanban } from "lucide-react";

const STATUS_META = {
  in_progress: { label: "In Progress", icon: Loader, color: "text-gold" },
  on_hold: { label: "On Hold", icon: PauseCircle, color: "text-white/60" },
  completed: { label: "Completed", icon: CheckCircle2, color: "text-gold" },
};

export default function AdminOverview({ onGoProjects }) {
  const [jobs, setJobs] = useState([]);
  const [clients, setClients] = useState([]);

  useEffect(() => {
    api.get("/admin/jobs").then((r) => setJobs(r.data)).catch(() => {});
    api.get("/admin/clients").then((r) => setClients(r.data)).catch(() => {});
  }, []);

  const stats = useMemo(() => {
    const by = { in_progress: 0, on_hold: 0, completed: 0 };
    jobs.forEach((j) => { by[j.status] = (by[j.status] || 0) + 1; });
    return by;
  }, [jobs]);

  const cards = [
    { label: "Total Projects", value: jobs.length, icon: FolderKanban },
    { label: "In Progress", value: stats.in_progress || 0, icon: Activity },
    { label: "On Hold", value: stats.on_hold || 0, icon: PauseCircle },
    { label: "Completed", value: stats.completed || 0, icon: CheckCircle2 },
    { label: "Clients", value: clients.length, icon: Users },
  ];

  return (
    <div>
      <h2 className="font-serif text-3xl md:text-4xl mb-8">Dashboard</h2>
      <div className="grid grid-cols-2 lg:grid-cols-5 gap-4 mb-10">
        {cards.map((c) => {
          const Icon = c.icon;
          return (
            <div key={c.label} data-testid={`stat-${c.label.toLowerCase().replace(/ /g, "-")}`} className="border border-white/10 bg-[#0a0a0a] p-6">
              <Icon size={22} className="text-gold mb-4" strokeWidth={1.5} />
              <p className="font-serif text-4xl">{c.value}</p>
              <p className="text-xs uppercase tracking-widest text-white/40 mt-1">{c.label}</p>
            </div>
          );
        })}
      </div>

      <div className="flex items-center justify-between mb-4">
        <h3 className="text-xs uppercase tracking-[0.25em] text-gold">Recent Projects</h3>
        <button onClick={onGoProjects} className="text-white/60 hover:text-gold text-sm link-underline">View all</button>
      </div>
      <div className="border border-white/10 divide-y divide-white/10">
        {jobs.slice(0, 6).map((j) => {
          const meta = STATUS_META[j.status] || STATUS_META.in_progress;
          const Icon = meta.icon;
          return (
            <div key={j.id} className="flex items-center justify-between gap-4 p-4">
              <div className="flex items-center gap-3 min-w-0">
                <Icon size={16} className={meta.color} />
                <div className="min-w-0">
                  <p className="font-body text-white truncate">{j.title}</p>
                  <p className="text-white/40 text-xs">{j.client_name} · {meta.label}</p>
                </div>
              </div>
              <div className="flex items-center gap-3 shrink-0 w-40">
                <div className="flex-1 h-1.5 bg-white/10"><div className="h-full bg-gold" style={{ width: `${j.progress || 0}%` }} /></div>
                <span className="text-xs text-gold w-10 text-right">{j.progress || 0}%</span>
              </div>
            </div>
          );
        })}
        {!jobs.length && <p className="text-white/40 font-body p-6">No projects yet.</p>}
      </div>
    </div>
  );
}
